'use client';
import Image from 'next/image';
import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';

import { AnimatedText } from '@/slw/shared/ui/animated-text';

export function HeroBanner() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.3 });

  return (
    <motion.section
      ref={ref}
      initial={{ opacity: 0, y: 40 }}
      animate={isInView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.8 }}
      className='
        relative
        w-full
        max-w-full
        h-[180px]
        sm:h-[220px]
        md:h-[260px]
        lg:h-[320px]
        xl:h-[460px]
        flex items-center justify-center
        rounded-2xl
        overflow-hidden
        md:mt-15 lg:mt-20 mt-6
      '
    >
      {/* Ảnh nền với animation */}
      <motion.div
        initial={{ opacity: 0, scale: 0.98 }}
        animate={isInView ? { opacity: 1, scale: 1 } : {}}
        transition={{ duration: 1, ease: 'easeOut' }}
        className='absolute inset-0 w-full h-full'
      >
        <Image
          src='/images/about-us/about-banner-car.png'
          alt='About Us Banner Car'
          fill
          className='object-cover object-center'
          priority
          quality={90}
          sizes='(max-width: 640px) 100vw, (max-width: 1024px) 80vw, 1360px'
        />
        {/* Overlay màu nâu */}
        <div className='absolute inset-0 z-10 bg-[#463928B2]' />
      </motion.div>
      {/* Text với animation */}
      <div className='relative z-20 flex flex-col items-center w-full text-center px-2 sm:px-4'>
        <AnimatedText
          text='Fueled by History, \nCrafted for Enthusiasts'
          className='text-white text-lg sm:text-2xl md:text-3xl leading-[120%] lg:text-[4rem] font-bold drop-shadow-lg'
        />
      </div>
    </motion.section>
  );
}
